import React from 'react';
import {
	FooterLogo,
	FooterRights,
	FooterWrapper,
	FooterAddress,
	FooterColumn,
	FooterGrid
} from './FooterStyles';
import { footerData, footerSocialData } from '../../data/FooterData';
import { Row, Section } from '../../globalStyles';


function Footer() {

return <Section padding="4rem 0 2rem 0">
  <FooterWrapper>
	  <FooterGrid justify="space-between">
		  <FooterColumn id="footerLogo">
			  <FooterLogo to="/">
				  Odvjetnik Mioč
			  </FooterLogo>
			  <FooterAddress>
				  Ilica 35
			  </FooterAddress>
			  <FooterAddress>
				 10000 Zagreb
			  </FooterAddress>
			  <FooterAddress>
				 Hrvatska
			  </FooterAddress>
			  <FooterAddress>
				  Tel: +385919709210
			  </FooterAddress>
			  <FooterAddress>
				  Email: anto.mioc5@gmail.com
			  </FooterAddress>
		  </FooterColumn>
	  </FooterGrid>
	  <FooterRights>Mioč Odvjetnik © 2023</FooterRights>
  </FooterWrapper>
</Section>

}

  


export default Footer;
